var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
var SvgNftLoading = function SvgNftLoading(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Mask, {
    id: "nft-loading_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#nft-loading_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M6.5 19.5c-1.382 0-2.56-.48-3.537-1.44-.975-.96-1.463-2.132-1.463-3.514 0-1.223.392-2.31 1.175-3.263.783-.953 1.783-1.516 2.998-1.69.32-1.496 1.072-2.718 2.255-3.668C9.11 4.975 10.468 4.5 12 4.5c1.809 0 3.345.631 4.607 1.893S18.5 9.191 18.5 11v.5h.308c1.053.082 1.932.506 2.636 1.271.704.765 1.056 1.675 1.056 2.729 0 1.115-.388 2.06-1.163 2.837-.776.775-1.722 1.163-2.837 1.163h-12Zm0-1.5h12c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C19.792 13.242 19.2 13 18.5 13H17v-2c0-1.383-.488-2.563-1.463-3.538C14.563 6.487 13.383 6 12 6s-2.563.487-3.538 1.462C7.487 8.437 7 9.617 7 11h-.5c-.967 0-1.792.342-2.475 1.025A3.372 3.372 0 0 0 3 14.5c0 .967.342 1.792 1.025 2.475A3.372 3.372 0 0 0 6.5 18Z",
    fill: "currentColor"
  }))));
};
export default SvgNftLoading;